
import {cancelTokenSource} from "../../hooks/hooks";

function AsbestosResultsTemplate() {
  // const axios = useAxios("localhost:1989")
  const source = cancelTokenSource;
  const NIL_COMMENT = "Nil";
  const CHRYSOTILE_POSITIVE_RESULT = "Chrysotile asbestos found";
  const AMOSITE_POSITIVE_RESULT = "Amosite asbestos found";
  const CROCIDOLITE_POSITIVE_RESULT = "Crocidolite asbestos found";
  const SMF_POSITIVE_RESULT = "Synthetic Mineral Fibres found";
  const OF_POSITIVE_RESULT = "Organic fibres found";
  const name = "Asbestos and SMF Results";
  const columns = [
    {
      title: "#",
      key: "id",
      dataIndex: "label_sample",
    },
    {
      title: "W",
      key: "width_sample",
      dataIndex: "width_sample",
    },
    {
      title: "H",
      key: "height_sample",
      dataIndex: "height_sample",
    },
    {
      title: "D",
      key: "depth_sample",
      dataIndex: "depth_sample",
    },
    {
      title: "Ch.",
      key: "is_chrysotile_sample",
      dataIndex: "is_chrysotile_sample",
      render: (v) => {
        return v === true ? "Yes" : "No";
      },
    },
    {
      title: "Am.",
      key: "is_amosite_sample",
      dataIndex: "is_amosite_sample",
      render: (v) => {
        return v === true ? "Yes" : "No";
      },
    },
    {
      title: "Cr.",
      key: "is_crocidolite_sample",
      dataIndex: "is_crocidolite_sample",
      render: (v) => {
        return v === true ? "Yes" : "No";
      },
    },
    {
      title: "SMF",
      key: "is_smf_sample",
      dataIndex: "is_smf_sample",
      render: (v) => {
        return v === true ? "Yes" : "No";
      },
    },
    {
      title: "Comments",
      key: "comments_sample",
      dataIndex: "comments_sample",
    },
  ];

  const addComment = (base, comment) => {
    var comma = base.length === 0 ? "" : ", ";
    if (comment === NIL_COMMENT) return base;
    base += comma + comment;
    return base;
  };

  const parse = (data) => {
    var ds = [];
    // var end = false;
    var sample = null, dimensions;
    for (var r of data) {
      if (r["Client Sample ID."] !== "") {
        if (sample !== null) {
          ds.push(sample)
        }
        sample = {};
        sample.key = r["Client Sample ID."];
        sample.info = "info";
        sample.label_sample = r["Client Sample ID."];
        dimensions = r["Sample Dimensions (cm) unless stated otherwise"].split(" x ");
        sample.width_sample = Number(dimensions[0]);
        sample.height_sample = Number(dimensions[1]);
        sample.depth_sample = Number(dimensions[2]);
        sample.comments_sample = "";
      }
      sample.is_chrysotile_sample = r['Result'] === CHRYSOTILE_POSITIVE_RESULT;
      sample.is_amosite_sample = r['Result'] === AMOSITE_POSITIVE_RESULT;
      sample.is_crocidolite_sample = r['Result'] === CROCIDOLITE_POSITIVE_RESULT;
      sample.is_smf_sample = r['Result'] === SMF_POSITIVE_RESULT;
      sample.comments_sample = addComment(sample.comments_sample, r['Comments'])
      if (r['Result'] === OF_POSITIVE_RESULT) {
        sample.comments_sample = addComment(
            sample.comments_sample,
            OF_POSITIVE_RESULT
        );
      }
    }
    return ds;
  };

  const apply = async (datasource, axios) => {
    var error = false;
    var len = datasource.length;
    for (var i = 0; i < len; i++) {
      var d = JSON.parse(JSON.stringify(datasource[i]));
      try {
        var get_response = await axios.current.get(
            'sample-results/?filter[label_sample]="' + d.label_sample + '"',
            // {cancelToken: cancelTokenSource.token}
        );
        if (get_response.error === true) {
          datasource[i].info = "danger";
          error = true;
          return {datasource, error};
        }
        if (get_response.data.rows.length !== 1) {
          datasource[i].info = "danger";
          error = true;
          return {datasource, error};
        }
        var sample = get_response.data.rows[0];
        var id_sample = sample.id_sample;
        var data = {};
        columns.forEach(function (c, i) {
          data[c.dataIndex] = d[c.dataIndex];
        });
        var response = await axios.current.put("sample-results/" + id_sample, data, {
          cancelToken: cancelTokenSource.token,
        });
        if (response.error === true) {
          datasource[i].info = "danger";
          error = true;
          return {datasource, error};
        }
        datasource[i].info = "success";
      } catch (e) {
        datasource[i].info = "danger";
        error = true;
      }
    }
    return {datasource, error};
  };

  return {
    source,
    name,
    columns,
    parse,
    apply,
  };
}
export default AsbestosResultsTemplate;
